import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    UploadButton,
    InputButtonContainer
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { SelectInput } from "../../../components/select/select";
import { useState } from "react";

//Registration schema
const schema = yup.object().shape({
    name: yup.string().required("Name is a required field"),
    email: yup.string().email().required("Email is a required field"),
    phoneNumber: yup.string().required("Phone Number is a required field"),
    school: yup.string().required("School is a required field"),
    subject: yup.string().required("Subject is a required field"),
});

const AdminAddInstructor = () => {
    const [imageUploadValue, setImageUploadValue] = useState('')

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }
    const subjectOptions = [
        {
            value: "english",
            label: "English Language",
        },
        {
            value: "mathematics",
            label: "Mathematics",
        },
    ];
    const classOptions = [
        {
            value: "jss1",
            label: "JSS 1",
        },
        {
            value: "jss2",
            label: "JSS 2",
        },
    ];

    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container >
                    <MainContent>
                        <Heading>
                            Instructors
                        </Heading>
                        <Breadcrumb
                            crumbs={['instructors', "add"]}
                        />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <InputWrapper>
                                <Input
                                    id="instructorName"
                                    label="Name"
                                    type="text"
                                    {...register("name")}
                                    error={errors.name?.message}
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper className="grid-2-2">
                                <Input
                                    id="instructorEmail"
                                    label="Email"
                                    type="text"
                                    {...register("email")}
                                    error={errors.email?.message}
                                    fullWidth
                                />
                                <Input
                                    id="instructorPhone"
                                    label="Phone number"
                                    type="text"
                                    {...register("phoneNumber")}
                                    error={errors.phoneNumber?.message}
                                    fullWidth
                                />

                            </InputWrapper>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="SCHOOL"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="SCHOOL"
                                                type="text"
                                                label="SCHOOL"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.school?.message}
                                                options={classOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="subject"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="subject"
                                                type="text"
                                                label='subject'
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.subject?.message}
                                                options={subjectOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <InputButtonContainer>
                                    <Input value={imageUploadValue} type='text' placeholder="Choose cover image" fullWidth />
                                    <label htmlFor="contained-button-file">
                                        <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                        <UploadButton variant="contained" component="span"
                                            disableElevation
                                            color="primary"
                                        >
                                            BROWSE
                                        </UploadButton>
                                    </label>
                                </InputButtonContainer>
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto', marginTop: '6rem' }}
                                responsive
                            >
                                ADD
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper >
    )
}

export default AdminAddInstructor
